import * as React from 'react'
import {Box, Typography} from "@mui/material";


export default function skuColumn() {
    return {
        name: 'sku', label: 'Category & SKU',
        options: {
			headerAlign: 'left',
            customBodyRowRenderLite: (value, { category }) => <Box>
				<Typography variant="caption" sx={{ display: 'block', color: "text.disabled" }}>
					{category}
				</Typography>
				<Typography variant="caption">
					{value}
				</Typography>
			</Box>
        }
    }
}